import {dateStringToNumber, deNumberStringToNumber} from "./utils"

const VALIDATORS = {
    from: (searchValue, range) => {
        return +deNumberStringToNumber(dateStringToNumber(searchValue)) >= +deNumberStringToNumber(dateStringToNumber(range.from))
            && +deNumberStringToNumber(dateStringToNumber(searchValue)) <= +deNumberStringToNumber(dateStringToNumber(range.till))
    },
    select: (searchValue, range) => range.select.includes(searchValue),
    value: (searchValue, range) => range.value ? (range.value === searchValue) : !searchValue,
}

export const validator = (searchValue, range) => {
    if (!range || !searchValue) {
        return false
    }

    const rangeType = Object.keys(range).find(key => VALIDATORS[key])

    if (rangeType) {
        return VALIDATORS[rangeType](searchValue, range)
    }
}